function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dhFilterFilled, vsRemove, vsCheck, vsFilter } from '@deephaven/icons';
import debounce from 'lodash.debounce';
import { ContextActions, ContextActionUtils, GLOBAL_SHORTCUTS } from '@deephaven/components';
import { GridMouseHandler, GridRange, GridRenderer, GridSelectionMouseHandler, isDeletableGridModel, isEditableGridModel, isExpandableColumnGridModel, isExpandableGridModel, parseValueFromText } from '@deephaven/grid';
import { TableColumnFormatter, DateTimeColumnFormatter, TableUtils } from '@deephaven/jsapi-utils';
import Log from '@deephaven/log';
import { ClipboardPermissionsDeniedError, ClipboardUnavailableError, TextUtils, assertNotEmpty, assertNotNaN, assertNotNull, copyToClipboard, readFromClipboard } from '@deephaven/utils';
import { DateTimeFormatContextMenu, DecimalFormatContextMenu, IntegerFormatContextMenu, TextAlignmentFormatContextMenu } from "../format-context-menus/index.js";
import "./IrisGridContextMenuHandler.css";
import SHORTCUTS from "../IrisGridShortcuts.js";
import { isPartitionedGridModel } from "../PartitionedGridModel.js";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('IrisGridContextMenuHandler');
var DEBOUNCE_UPDATE_FORMAT = 150;
var CONTEXT_MENU_DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss.SSSSSSSSS';
var MAX_MULTISELECT_ROWS = 1000;

/**
 * Used to eat the mouse event in the bottom right corner of the scroll bar
 */
class IrisGridContextMenuHandler extends GridMouseHandler {
  /**
   * Get filter condition for quick filter and combines with a new filter using the operator specified,
   * returns new filter if no operator supplied.
   * @param columnFilter
   * @param newColumnFilter
   * @param operator
   */
  static getQuickFilterCondition(columnFilter, newColumnFilter, operator) {
    if (columnFilter && operator === '&&') {
      return columnFilter.and(newColumnFilter);
    }
    if (columnFilter && operator === '||') {
      return columnFilter.or(newColumnFilter);
    }
    return newColumnFilter;
  }

  /**
   * combines filter text with operator if declared
   * @param filterText
   * @param newFilterText
   * @param operator
   */
  static getQuickFilterText(filterText, newFilterText, operator) {
    return operator && filterText != null ? "".concat(filterText, " ").concat(operator, " ").concat(newFilterText) : newFilterText;
  }

  /**
   * Converts operator to text string,
   */
  static getOperatorAsText(operator) {
    return operator === '&&' ? 'And' : 'Or';
  }
  static getRowOptionFormatted(command, cellValue) {
    var len = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
    return "".concat(command, " \"").concat(GridRenderer.truncate(cellValue, len - command.length - 3), "\"");
  }
  constructor(irisGrid, dh) {
    super();
    _defineProperty(this, "irisGrid", void 0);
    _defineProperty(this, "debouncedUpdateCustomFormat", void 0);
    _defineProperty(this, "dh", void 0);
    this.getNumberValueEqualsFilter = this.getNumberValueEqualsFilter.bind(this);
    this.getFilterValueForNumberOrChar = this.getFilterValueForNumberOrChar.bind(this);
    this.debouncedUpdateCustomFormat = debounce(irisGrid.handleFormatSelection, DEBOUNCE_UPDATE_FORMAT);
    this.dh = dh;
    this.irisGrid = irisGrid;
  }
  componentWillUnmount() {
    this.debouncedUpdateCustomFormat.flush();
  }
  getHeaderActions(modelIndex, gridPoint) {
    var irisGrid = this.irisGrid;
    var visibleIndex = gridPoint.column;
    assertNotNull(visibleIndex);
    var model = irisGrid.props.model;
    var columns = model.columns;
    var column = columns[modelIndex];
    var actions = [];
    var _irisGrid$state = irisGrid.state,
      metrics = _irisGrid$state.metrics,
      reverse = _irisGrid$state.reverse,
      quickFilters = _irisGrid$state.quickFilters,
      advancedFilters = _irisGrid$state.advancedFilters,
      searchFilter = _irisGrid$state.searchFilter;
    var theme = irisGrid.getTheme();
    assertNotNull(metrics);
    var filterIconColor = theme.filterIconColor,
      filterBarActiveColor = theme.filterBarActiveColor,
      contextMenuSortIconColor = theme.contextMenuSortIconColor,
      contextMenuReverseIconColor = theme.contextMenuReverseIconColor;
    var modelSort = model.sort;
    var columnSort = TableUtils.getSortForColumn(modelSort, column.name);
    var userColumnWidths = metrics.userColumnWidths;
    var isColumnHidden = [...userColumnWidths.values()].some(columnWidth => columnWidth === 0);
    var isColumnFreezable = model.getColumnHeaderParentGroup(modelIndex, 0) === undefined && !(isExpandableGridModel(model) && model.hasExpandableRows);
    var isColumnFrozen = model.isColumnFrozen(modelIndex);
    var isColumnSortable = model.isColumnSortable(modelIndex);
    actions.push({
      title: 'Hide Column',
      group: IrisGridContextMenuHandler.GROUP_HIDE_COLUMNS,
      action: () => {
        this.irisGrid.hideColumnByVisibleIndex(visibleIndex);
      }
    });
    actions.push({
      title: isColumnFrozen ? 'Unfreeze Column' : 'Freeze Column',
      group: IrisGridContextMenuHandler.GROUP_HIDE_COLUMNS,
      disabled: !isColumnFreezable,
      action: () => {
        if (isColumnFrozen) {
          this.irisGrid.unFreezeColumnByColumnName(column.name);
        } else {
          this.irisGrid.freezeColumnByColumnName(column.name);
        }
      },
      order: 30
    });
    actions.push({
      title: 'Show All Columns',
      group: IrisGridContextMenuHandler.GROUP_HIDE_COLUMNS,
      action: () => {
        this.irisGrid.showAllColumns();
      },
      disabled: !isColumnHidden
    });
    if (isExpandableColumnGridModel(model) && model.hasExpandableColumns) {
      if (model.isExpandAllColumnsAvailable) {
        actions.push({
          title: 'Expand All Columns',
          group: IrisGridContextMenuHandler.GROUP_EXPAND_COLLAPSE,
          order: 30,
          action: () => {
            this.irisGrid.expandAllColumns();
          }
        });
        actions.push({
          title: 'Collapse All Columns',
          group: IrisGridContextMenuHandler.GROUP_EXPAND_COLLAPSE,
          order: 40,
          action: () => {
            this.irisGrid.collapseAllColumns();
          }
        });
      }
    }
    actions.push({
      title: 'Resize Column',
      group: IrisGridContextMenuHandler.GROUP_HIDE_COLUMNS,
      action: () => {
        this.irisGrid.handleResizeColumn(modelIndex);
      },
      order: 10
    });
    actions.push({
      title: 'Resize All Columns',
      group: IrisGridContextMenuHandler.GROUP_HIDE_COLUMNS,
      action: () => {
        this.irisGrid.handleResizeAllColumns();
      },
      order: 20
    });
    actions.push({
      title: 'Quick Filters',
      icon: vsRemove,
      iconColor: filterBarActiveColor,
      shortcut: SHORTCUTS.TABLE.TOGGLE_QUICK_FILTER,
      group: IrisGridContextMenuHandler.GROUP_FILTER,
      order: 10,
      action: () => {
        this.irisGrid.toggleFilterBar(visibleIndex);
      },
      disabled: !model.isFilterable(modelIndex)
    });
    actions.push({
      title: 'Advanced Filters',
      icon: advancedFilters.get(modelIndex) ? dhFilterFilled : vsFilter,
      iconColor: filterIconColor,
      group: IrisGridContextMenuHandler.GROUP_FILTER,
      order: 20,
      action: () => {
        this.irisGrid.handleAdvancedMenuOpened(visibleIndex);
      },
      disabled: !model.isFilterable(modelIndex)
    });
    actions.push({
      title: 'Clear Table Filters',
      group: IrisGridContextMenuHandler.GROUP_FILTER,
      order: 40,
      // this just displays the shortcut, the actual listener is in irisgrid handleKeyDown
      shortcut: SHORTCUTS.TABLE.CLEAR_FILTERS,
      action: () => {
        this.irisGrid.clearAllFilters();
      },
      disabled: !(quickFilters.size > 0 || advancedFilters.size > 0 || searchFilter != null)
    });
    actions.push({
      title: 'Sort by',
      icon: vsRemove,
      iconColor: contextMenuSortIconColor,
      group: IrisGridContextMenuHandler.GROUP_SORT,
      order: 10,
      actions: this.sortByActions(column, modelIndex, columnSort),
      disabled: !isColumnSortable
    });
    actions.push({
      title: 'Add Additional Sort',
      /**
       * disable conditions:
       * 1. table is sorted only by this column
       * 2. table is only reversed
       * 3. 1 & 2 combined
       * 4. table has no sort
       * reverse is a type of sort, so needs to be accounted for in exclusions
       * */
      disabled: columnSort && modelSort.length === 1 || reverse && modelSort.length === 1 || columnSort && reverse && modelSort.length === 2 || modelSort.length === 0 || !isColumnSortable,
      group: IrisGridContextMenuHandler.GROUP_SORT,
      order: 20,
      actions: this.additionalSortActions(column, modelIndex)
    });
    actions.push({
      title: 'Clear Table Sorting',
      disabled:
      // reverse is a type of sort, but special and needs to be exluded despite being part of model.sort
      modelSort.length === 0 || reverse && modelSort.length === 1,
      group: IrisGridContextMenuHandler.GROUP_SORT,
      action: () => {
        this.irisGrid.sortColumn(visibleIndex, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.none);
      },
      order: 30
    });
    actions.push({
      title: reverse ? 'Clear Reverse Table' : 'Reverse Table',
      icon: vsRemove,
      iconColor: contextMenuReverseIconColor,
      group: IrisGridContextMenuHandler.GROUP_SORT,
      order: 40,
      disabled: !model.isReversible,
      // this just displays the shortcut, the actual listener is in irisgrid handleKeyDown
      shortcut: SHORTCUTS.TABLE.REVERSE,
      action: () => {
        this.irisGrid.reverse(!reverse);
      }
    });
    actions.push({
      title: 'Copy Column Name',
      group: IrisGridContextMenuHandler.GROUP_COPY,
      shortcutText: ContextActionUtils.isMacPlatform() ? '⌥Click' : 'Alt+Click',
      action: () => {
        var _model$textForColumnH;
        copyToClipboard((_model$textForColumnH = model.textForColumnHeader(modelIndex)) !== null && _model$textForColumnH !== void 0 ? _model$textForColumnH : '').catch(e => log.error('Unable to copy header', e));
      }
    });
    if (TableUtils.isDateType(column.type)) {
      actions.push({
        title: 'Date/Time Format',
        group: IrisGridContextMenuHandler.GROUP_FORMAT,
        actions: this.dateFormatActions(column)
      });
    } else if (TableUtils.isNumberType(column.type)) {
      var _this$numberFormatAct;
      actions.push({
        title: 'Number Format',
        group: IrisGridContextMenuHandler.GROUP_FORMAT,
        actions: (_this$numberFormatAct = this.numberFormatActions(column)) !== null && _this$numberFormatAct !== void 0 ? _this$numberFormatAct : undefined
      });
    }
    actions.push({
      title: 'Text Alignment',
      group: IrisGridContextMenuHandler.GROUP_FORMAT,
      actions: this.textAlignmentFormatActions(column)
    });
    return actions;
  }
  getCellActions(modelColumn, grid, gridPoint) {
    var irisGrid = this.irisGrid;
    var columnIndex = gridPoint.column,
      rowIndex = gridPoint.row;
    var _irisGrid$props = irisGrid.props,
      model = _irisGrid$props.model,
      canCopy = _irisGrid$props.canCopy;
    var columns = model.columns;
    var modelRow = irisGrid.getModelRow(rowIndex);
    assertNotNull(modelRow);
    var sourceCell = model.sourceForCell(modelColumn, modelRow);
    var sourceColumn = sourceCell.column,
      sourceRow = sourceCell.row;
    var selectedRanges = irisGrid.state.selectedRanges;
    var column = columns[sourceColumn];
    var actions = [];
    var theme = irisGrid.getTheme();
    var filterIconColor = theme.filterIconColor;
    if (column == null || rowIndex == null) return actions;

    // Expand/Collapse options
    if (isExpandableGridModel(model) && model.isRowExpandable(sourceRow)) {
      // If there are grouped columns, then it is a rollup
      // The first column will be the "group" column with the value that should be expanded
      var expandingColumn = 0;
      var cellValue = model.valueForCell(expandingColumn, sourceRow);
      var cellText = cellValue == null ? 'null' : model.textForCell(expandingColumn, sourceRow);
      actions.push({
        title: IrisGridContextMenuHandler.getRowOptionFormatted(model.isRowExpanded(sourceRow) ? 'Collapse' : 'Expand', cellText),
        group: IrisGridContextMenuHandler.GROUP_EXPAND_COLLAPSE,
        order: 10,
        action: () => {
          model.setRowExpanded(sourceRow, !model.isRowExpanded(sourceRow));
        }
      });
      if (model.isExpandAllAvailable === true) {
        actions.push({
          title: IrisGridContextMenuHandler.getRowOptionFormatted('Expand All in', cellText),
          group: IrisGridContextMenuHandler.GROUP_EXPAND_COLLAPSE,
          order: 20,
          action: () => {
            model.setRowExpanded(sourceRow, true, true);
          }
        });
      }
    }
    if (isExpandableGridModel(model) && model.hasExpandableRows && model.isExpandAllAvailable === true) {
      actions.push({
        title: 'Expand Entire Table',
        group: IrisGridContextMenuHandler.GROUP_EXPAND_COLLAPSE,
        order: 30,
        action: () => {
          model.expandAll();
        }
      });
      actions.push({
        title: 'Collapse Entire Table',
        group: IrisGridContextMenuHandler.GROUP_EXPAND_COLLAPSE,
        order: 40,
        action: () => {
          model.collapseAll();
        }
      });
    }
    var gotoRow = {
      title: 'Go to',
      iconColor: filterIconColor,
      shortcut: SHORTCUTS.TABLE.GOTO_ROW,
      group: IrisGridContextMenuHandler.GROUP_GOTO,
      order: 10,
      action: () => {
        // Use raw value (same as Copy Cell Unformatted) to preserve full precision and timezone
        var rawValue = String(irisGrid.getValueForCell(columnIndex, rowIndex, true));
        this.irisGrid.toggleGotoRow("".concat(rowIndex + 1), rawValue, column.name);
      }
    };
    actions.push(gotoRow);
    if (canCopy) {
      actions.push({
        title: 'Copy Cell',
        group: IrisGridContextMenuHandler.GROUP_COPY,
        shortcutText: ContextActionUtils.isMacPlatform() ? '⌥Click' : 'Alt+Click',
        order: 10,
        action: () => {
          irisGrid.copyCell(columnIndex, rowIndex);
        }
      });
      actions.push({
        title: 'Copy Cell Unformatted',
        group: IrisGridContextMenuHandler.GROUP_COPY,
        order: 20,
        action: () => {
          irisGrid.copyCell(columnIndex, rowIndex, true);
        }
      });
    }
    if (isEditableGridModel(model) && model.isEditable) {
      // selectedRanges is updated by GridSelectionMouseHandler in the same cycle so can't access the updated value here
      // so need to handle cases where a cell is right clicked without highlighting it first
      var canPasteInOriginalRange = selectedRanges.every(range => model.isEditableRange(range));

      // To account for how when a cell outside of a selection is right clicked, that selection gets cleared
      var isCellInOriginalRange = GridRange.containsCell(selectedRanges, columnIndex, rowIndex);
      var canPasteInCell = model.isEditableRange(GridRange.makeCell(columnIndex, rowIndex));
      if ((canPasteInOriginalRange || !isCellInOriginalRange) && canPasteInCell) {
        actions.push({
          title: 'Paste',
          group: IrisGridContextMenuHandler.GROUP_COPY,
          order: 50,
          action: function () {
            var _action = _asyncToGenerator(function* () {
              try {
                var text = yield readFromClipboard();
                var value = parseValueFromText(text);
                yield grid.pasteValue(value);
              } catch (err) {
                if (err instanceof ClipboardUnavailableError) {
                  irisGrid.handleOpenNoPastePermissionModal('For security reasons your browser does not allow access to your clipboard on click.');
                } else if (err instanceof ClipboardPermissionsDeniedError) {
                  irisGrid.handleOpenNoPastePermissionModal('Requested clipboard permissions have not been granted, please grant them and try again.');
                } else {
                  throw err;
                }
              }
            });
            function action() {
              return _action.apply(this, arguments);
            }
            return action;
          }()
        });
      }
    }
    actions.push({
      title: 'View Cell Contents',
      group: IrisGridContextMenuHandler.GROUP_VIEW_CONTENTS,
      order: 10,
      action: () => {
        irisGrid.setState({
          showOverflowModal: true,
          overflowText: irisGrid.getValueForCell(columnIndex, rowIndex)
        });
      }
    });
    if (isPartitionedGridModel(model) && !model.isPartitionAwareSourceTable) {
      actions.push({
        title: 'View Constituent Table',
        group: IrisGridContextMenuHandler.GROUP_VIEW_CONTENTS,
        order: 40,
        action: () => {
          irisGrid.selectPartitionKeyFromTable(rowIndex);
        }
      });
    }
    return actions;
  }

  // moved out of getCellActions since snapshots are async
  getCellFilterActions(modelColumn, grid, gridPoint) {
    var _this = this;
    return _asyncToGenerator(function* () {
      var dh = _this.dh,
        irisGrid = _this.irisGrid;
      var rowIndex = gridPoint.row;
      var model = irisGrid.props.model;
      var columns = model.columns;
      var modelRow = irisGrid.getModelRow(rowIndex);
      var getSelectedRanges = grid.getSelectedRanges;
      assertNotNull(modelRow);
      var sourceCell = model.sourceForCell(modelColumn, modelRow);
      var sourceColumn = sourceCell.column,
        sourceRow = sourceCell.row;
      var column = columns[sourceColumn];
      if (column == null || rowIndex == null) return [];
      if (!model.isFilterable(sourceColumn)) return [];
      var quickFilters = irisGrid.state.quickFilters;
      var theme = irisGrid.getTheme();
      var filterIconColor = theme.filterIconColor;
      var settings = irisGrid.props.settings;
      var selectedRanges = [...getSelectedRanges()];
      // no selected range (i.e. right clicked a cell without highlighting it)
      // although GridSelectionMouseHandler does change selectedRanges, state isn't updated in
      //   time for getSelectedRanges to show the selected cell
      if (selectedRanges.length === 0) {
        selectedRanges.push(new GridRange(sourceColumn, sourceRow, sourceColumn, sourceRow));
      }

      // - this block truncates the selected ranges to MAX_MULTISELECT_ROWS rows
      //   - NOT first MAX_MULTISELECT_ROWS rows after the first row
      //   - NOT first MAX_MULTISELECT_ROWS unique values (prevent case where there are a small
      //     amount of values, but a large amount of rows with those values)
      if (GridRange.containsCell(selectedRanges, sourceColumn, sourceRow)) {
        var rowCount = GridRange.rowCount(selectedRanges);
        while (rowCount > MAX_MULTISELECT_ROWS) {
          var lastRow = selectedRanges.pop();
          // should never occur, sanity check
          assertNotNull(lastRow, 'Selected ranges should not be empty');
          var lastRowSize = GridRange.rowCount([lastRow]);
          // should never occur, sanity check
          assertNotNaN(lastRowSize, 'Selected ranges should not be unbounded');

          // if removing the last rows makes it dip below the max, then need to
          //   bring it back but truncated
          if (rowCount - lastRowSize < MAX_MULTISELECT_ROWS) {
            var _lastRow$endRow;
            // nullish operator to make TS happy, but the check above should prevent this
            selectedRanges.push(new GridRange(lastRow.startColumn, lastRow.startRow, lastRow.endColumn, ((_lastRow$endRow = lastRow.endRow) !== null && _lastRow$endRow !== void 0 ? _lastRow$endRow : 0) - (rowCount - MAX_MULTISELECT_ROWS)));
            break;
          }
          rowCount -= lastRowSize;
        }
      } else {
        // if the block is not in the selected ranges, meaning the user must've right-clicked
        // outside the selected ranges`
        selectedRanges = [new GridRange(sourceColumn, sourceRow, sourceColumn, sourceRow)];
      }

      // this should be non empty
      //  - valid selected ranges will always have a startRow and endRow
      //  - if there are no selected ranges, then one with sourceColumn/Row is added
      assertNotEmpty(selectedRanges);

      // get the snapshot values, but ignore all null/undefined values
      var snapshot = yield model.snapshot(selectedRanges);
      var snapshotValues = new Set();
      for (var i = 0; i < snapshot.length; i += 1) {
        if (snapshot[i].length === 1) {
          // if the selected range has start/end columns defined, so the snapshot is a 1D array of the row
          if (snapshot[i][0] != null) {
            snapshotValues.add(snapshot[i][0]);
          }
        } else if (snapshot[i][sourceColumn] != null) {
          // if the selected range is an entire row
          snapshotValues.add(snapshot[i][sourceColumn]);
        }
      }
      // if snapshotValues is empty here, it means all of the snapshot's values were null/undefined

      var filterMenu = {
        title: "Filter by Value".concat(snapshotValues.size > 1 ? 's' : ''),
        icon: vsRemove,
        iconColor: filterIconColor,
        group: IrisGridContextMenuHandler.GROUP_FILTER,
        order: 10,
        actions: []
      };

      // only made of null/undefineds
      if (snapshotValues.size === 0) {
        // null gets a special menu
        if (quickFilters.get(sourceColumn)) {
          filterMenu.actions.push({
            title: 'And',
            actions: _this.nullFilterActions(column, quickFilters.get(sourceColumn), '&&'),
            order: 2,
            group: ContextActions.groups.high
          });
        }
        filterMenu.actions.push(..._this.nullFilterActions(column));
      } else if (snapshotValues.size === 1 && snapshotValues.has('')) {
        // empty string gets a special menu
        if (quickFilters.get(sourceColumn)) {
          filterMenu.actions.push({
            title: 'And',
            actions: _this.emptyStringFilterActions(column, quickFilters.get(sourceColumn), '&&'),
            order: 2,
            group: ContextActions.groups.high
          });
        }
        filterMenu.actions.push(..._this.emptyStringFilterActions(column));
      } else if (TableUtils.isBooleanType(column.type)) {
        // boolean should have OR condition, and handles it's own null menu options
        if (quickFilters.get(sourceColumn)) {
          filterMenu.actions.push({
            title: 'Or',
            actions: _this.booleanFilterActions(column, model.textForCell(sourceColumn, sourceRow), quickFilters.get(sourceColumn), '||'),
            order: 2,
            group: ContextActions.groups.high
          });
        }
        filterMenu.actions.push(..._this.booleanFilterActions(column, model.textForCell(sourceColumn, sourceRow)));
      } else if (TableUtils.isNumberType(column.type) || TableUtils.isCharType(column.type)) {
        // Chars get treated like numbers in terms of which filters are available
        assertNotNull(sourceColumn);
        if (quickFilters.get(sourceColumn)) {
          filterMenu.actions.push({
            title: 'And',
            actions: _this.numberFilterActions(column, snapshotValues, quickFilters.get(sourceColumn), '&&'),
            order: 2,
            group: ContextActions.groups.high
          });
        }
        filterMenu.actions.push(..._this.numberFilterActions(column, snapshotValues, quickFilters.get(sourceColumn)));
      } else if (TableUtils.isDateType(column.type)) {
        var dateFilterFormatter = new DateTimeColumnFormatter(dh, {
          timeZone: settings === null || settings === void 0 ? void 0 : settings.timeZone,
          showTimeZone: false,
          showTSeparator: true,
          defaultDateTimeFormatString: CONTEXT_MENU_DATE_FORMAT
        });
        var previewFilterFormatter = new DateTimeColumnFormatter(dh, {
          timeZone: settings === null || settings === void 0 ? void 0 : settings.timeZone,
          showTimeZone: settings === null || settings === void 0 ? void 0 : settings.showTimeZone,
          showTSeparator: settings === null || settings === void 0 ? void 0 : settings.showTSeparator,
          defaultDateTimeFormatString: CONTEXT_MENU_DATE_FORMAT
        });
        if (quickFilters.get(sourceColumn)) {
          filterMenu.actions.push({
            title: 'And',
            actions: _this.dateFilterActions(column, snapshotValues, dateFilterFormatter, previewFilterFormatter, quickFilters.get(sourceColumn), '&&'),
            order: 2,
            group: ContextActions.groups.high
          });
        }
        filterMenu.actions.push(..._this.dateFilterActions(column, snapshotValues, dateFilterFormatter, previewFilterFormatter, quickFilters.get(sourceColumn)));
      } else {
        if (quickFilters.get(sourceColumn)) {
          filterMenu.actions.push({
            title: 'And',
            actions: _this.stringFilterActions(column, snapshotValues, quickFilters.get(sourceColumn), '&&'),
            order: 2,
            group: ContextActions.groups.high
          });
        }
        filterMenu.actions.push(..._this.stringFilterActions(column, snapshotValues));
      }
      return [filterMenu];
    })();
  }

  /**
   * Gets an equality filter for the provided numeric value
   * @param column The column to make the filter for
   * @param value The value to get the equality filter for
   */
  getNumberValueEqualsFilter(column, value) {
    var dh = this.dh;
    var columnFilter = column.filter();
    if (value === Number.POSITIVE_INFINITY) {
      return dh.FilterCondition.invoke('isInf', columnFilter).and(columnFilter.greaterThan(dh.FilterValue.ofNumber(0)));
    }
    if (value === Number.NEGATIVE_INFINITY) {
      return dh.FilterCondition.invoke('isInf', columnFilter).and(columnFilter.lessThan(dh.FilterValue.ofNumber(0)));
    }
    if (Number.isNaN(value)) {
      return dh.FilterCondition.invoke('isNaN', columnFilter);
    }
    var filterValue = this.getFilterValueForNumberOrChar(column.type, value);
    return columnFilter.eq(filterValue);
  }
  getFilterValueForNumberOrChar(columnType, value) {
    var dh = this.dh;
    return TableUtils.isCharType(columnType) ? dh.FilterValue.ofString(String.fromCharCode(value)) : dh.FilterValue.ofNumber(value);
  }
  onContextMenu(gridPoint, grid, event) {
    var irisGrid = this.irisGrid;
    var y = gridPoint.y,
      columnIndex = gridPoint.column,
      rowIndex = gridPoint.row,
      columnHeaderDepth = gridPoint.columnHeaderDepth;
    var modelColumn = irisGrid.getModelColumn(columnIndex);
    var modelRow = irisGrid.getModelRow(rowIndex);
    var _irisGrid$props2 = irisGrid.props,
      model = _irisGrid$props2.model,
      canCopy = _irisGrid$props2.canCopy;
    var columns = model.columns;
    var _irisGrid$state2 = irisGrid.state,
      metrics = _irisGrid$state2.metrics,
      isFilterBarShown = _irisGrid$state2.isFilterBarShown,
      quickFilters = _irisGrid$state2.quickFilters,
      advancedFilters = _irisGrid$state2.advancedFilters,
      stateSelectedRanges = _irisGrid$state2.selectedRanges;
    var selectedRanges = GridSelectionMouseHandler.getLatestSelection(stateSelectedRanges, columnIndex, rowIndex);
    assertNotNull(metrics);
    var columnHeaderHeight = metrics.columnHeaderHeight,
      gridY = metrics.gridY,
      columnHeaderMaxDepth = metrics.columnHeaderMaxDepth;
    var actions = [];
    if (modelColumn != null && modelRow != null) {
      var sourceCell = model.sourceForCell(modelColumn, modelRow !== null && modelRow !== void 0 ? modelRow : 0);
      var sourceColumn = sourceCell.column,
        sourceRow = sourceCell.row;
      var value = model.valueForCell(sourceColumn, sourceRow);
      var valueText = model.textForCell(sourceColumn, sourceRow);
      var column = columns[sourceColumn];
      var onContextMenu = irisGrid.props.onContextMenu;
      if (column != null) {
        actions.push(...onContextMenu({
          model,
          value,
          valueText,
          column,
          rowIndex,
          columnIndex,
          modelRow,
          modelColumn
        }));
      }
    }
    if (modelColumn != null) {
      var clearFilterRange = model.getClearFilterRange(modelColumn);
      if (clearFilterRange != null && clearFilterRange.length > 0) {
        // Clear column filter should still be available after last row
        // And should be available in both header and body context menus
        actions.push({
          title: clearFilterRange[1] - clearFilterRange[0] > 0 ? 'Clear Group Filter' : 'Clear Column Filter',
          group: IrisGridContextMenuHandler.GROUP_FILTER,
          order: 30,
          action: () => {
            this.irisGrid.removeColumnFilter(clearFilterRange);
          },
          disabled: !Array.from(quickFilters.keys()).some(col => col >= clearFilterRange[0] && col <= clearFilterRange[1]) && !Array.from(advancedFilters.keys()).some(col => col >= clearFilterRange[0] && col <= clearFilterRange[1])
        });
      }
    }
    if (isFilterBarShown ? y <= gridY : y <= columnHeaderHeight * columnHeaderMaxDepth && columnHeaderDepth === 0) {
      // grid header context menu options
      if (modelColumn != null) {
        actions.push(...this.getHeaderActions(modelColumn, gridPoint));
      }
    } else {
      // grid body context menu options
      if (modelColumn != null && modelRow != null) {
        actions.push(...this.getCellActions(modelColumn, grid, gridPoint));
        actions.push(this.getCellFilterActions(modelColumn, grid, gridPoint));
      }

      // blank space context menu options
      if (canCopy && selectedRanges.length > 0) {
        actions.push({
          title: 'Copy Selection',
          shortcut: GLOBAL_SHORTCUTS.COPY,
          group: IrisGridContextMenuHandler.GROUP_COPY,
          order: 30,
          action: () => {
            irisGrid.copyRanges(selectedRanges);
          }
        });
        actions.push({
          title: 'Copy Selection w/ Headers',
          group: IrisGridContextMenuHandler.GROUP_COPY,
          order: 40,
          action: () => {
            irisGrid.copyRanges(selectedRanges, true);
          }
        });
      }
      if (isEditableGridModel(model) && model.isEditable && selectedRanges.length > 0 && isDeletableGridModel(model) && model.isDeletable) {
        actions.push({
          title: 'Delete Selected Rows',
          group: IrisGridContextMenuHandler.GROUP_EDIT,
          disabled: !model.isDeletableRanges(selectedRanges),
          order: 50,
          action: () => {
            this.irisGrid.deleteRanges(selectedRanges);
          }
        });
      }
    }
    if (actions.length === 0) {
      return false;
    }
    assertNotNull(irisGrid.gridWrapper);
    ContextActions.triggerMenu(irisGrid.gridWrapper, event.clientX, event.clientY, actions);
    return true;
  }
  dateFormatActions(column) {
    var _this2 = this;
    var model = this.irisGrid.props.model;
    var formatter = model.formatter;
    var selectedFormat = formatter.getColumnFormat(column.type, column.name);
    var formatOptions = DateTimeFormatContextMenu.getOptions(formatter, selectedFormat);
    var actions = [];
    var _loop = function _loop() {
      var _formatOptions$i = formatOptions[i],
        description = _formatOptions$i.description,
        format = _formatOptions$i.format,
        group = _formatOptions$i.group,
        isSelected = _formatOptions$i.isSelected,
        title = _formatOptions$i.title;
      actions.push({
        title,
        description,
        icon: isSelected ? vsCheck : undefined,
        group,
        order: i,
        action: () => {
          var modelIndex = model.getColumnIndexByName(column.name);
          assertNotNull(modelIndex);
          _this2.irisGrid.handleFormatSelection(modelIndex, format);
        }
      });
    };
    for (var i = 0; i < formatOptions.length; i += 1) {
      _loop();
    }
    return actions;
  }
  numberFormatActions(column) {
    var _this3 = this;
    var model = this.irisGrid.props.model;
    var formatter = model.formatter;
    var dh = this.dh;
    var selectedFormat = formatter.getColumnFormat(column.type, column.name);
    var formatOptions;
    var columnIndex = model.getColumnIndexByName(column.name);
    if (TableUtils.isDecimalType(column.type)) {
      formatOptions = DecimalFormatContextMenu.getOptions(dh, selectedFormat, format => {
        assertNotNull(columnIndex);
        this.debouncedUpdateCustomFormat(columnIndex, format);
      });
    } else if (TableUtils.isIntegerType(column.type)) {
      formatOptions = IntegerFormatContextMenu.getOptions(dh, selectedFormat, format => {
        assertNotNull(columnIndex);
        this.debouncedUpdateCustomFormat(columnIndex, format);
      });
    } else {
      log.error('Invalid column type in numberFormatActions');
      return null;
    }
    var actions = [];
    var _loop2 = function _loop2() {
      var _formatOptions$i2 = formatOptions[i],
        format = _formatOptions$i2.format,
        isSelected = _formatOptions$i2.isSelected;
      actions.push(_objectSpread(_objectSpread({}, formatOptions[i]), {}, {
        icon: isSelected ? vsCheck : undefined,
        order: i,
        action: () => {
          if (columnIndex === undefined && format && format.type === TableColumnFormatter.TYPE_CONTEXT_CUSTOM) {
            return;
          }
          assertNotNull(columnIndex);
          _this3.irisGrid.handleFormatSelection(columnIndex, format);
        }
      }));
    };
    for (var i = 0; i < formatOptions.length; i += 1) {
      _loop2();
    }
    return actions;
  }
  textAlignmentFormatActions(column) {
    var model = this.irisGrid.props.model;
    var columnAlignmentMap = this.irisGrid.state.columnAlignmentMap;
    var modelIndex = model.getColumnIndexByName(column.name);
    assertNotNull(modelIndex);
    var currentAlignment = columnAlignmentMap.get(column.name);
    return TextAlignmentFormatContextMenu.alignmentOptions.map((option, index) => ({
      title: option.title,
      icon: currentAlignment == null && option.alignment == null || currentAlignment === option.alignment ? vsCheck : option.icon,
      order: index,
      group: option.group,
      action: () => {
        this.irisGrid.handleColumnAlignmentChange(modelIndex, option.alignment);
      }
    }));
  }
  stringFilterActions(column, snapshotValues, quickFilter, operator) {
    var dh = this.dh;
    var values = Array.from(snapshotValues.keys());
    var filterValues = values.map(value => dh.FilterValue.ofString(value));
    var valueDescription = filterValues.length === 1 ? filterValues[0] : 'the selected values';
    var newQuickFilter = quickFilter;
    if (!newQuickFilter) {
      newQuickFilter = {
        filter: null,
        text: null
      };
    }
    var _newQuickFilter = newQuickFilter,
      filter = _newQuickFilter.filter,
      filterText = _newQuickFilter.text;
    var actions = [];
    var model = this.irisGrid.props.model;
    var columnIndex = model.getColumnIndexByName(column.name);
    var toFilterText = item => {
      var _TableUtils$escapeQui;
      return (_TableUtils$escapeQui = TableUtils.escapeQuickTextFilter(item)) !== null && _TableUtils$escapeQui !== void 0 ? _TableUtils$escapeQui : '';
    };
    assertNotNull(columnIndex);
    actions.push({
      menuElement: /*#__PURE__*/_jsxs("div", {
        className: "iris-grid-filter-menu-item-value",
        children: [operator ? IrisGridContextMenuHandler.getOperatorAsText(operator) : '', ' ', TextUtils.join(values.slice(0, 20).map(value => "\"".concat(toFilterText(value), "\""))), values.length > 1 && /*#__PURE__*/_jsxs("div", {
          className: "iris-grid-filter-menu-subtitle",
          children: ["(", values.length, " values selected)"]
        })]
      }),
      order: 1,
      group: ContextActions.groups.high
    });
    actions.push({
      title: 'text is exactly',
      description: "Show only rows where ".concat(column.name, " is ").concat(valueDescription, " (case sensitive)"),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, filterValues.map(filterValue => column.filter().eq(filterValue)).reduce((prev, curr) => prev.or(curr)), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, values.map(toFilterText).join(' || '), operator));
      },
      order: 10,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'text is not exactly',
      description: "Show only rows where ".concat(column.name, " is not ").concat(valueDescription, " (case sensitive)"),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, filterValues.map(filterValue => column.filter().notEq(filterValue)).reduce((prev, curr) => prev.and(curr)), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, values.map(value => "!=".concat(toFilterText(value))).join(' && '), operator));
      },
      order: 20,
      group: ContextActions.groups.low
    });
    actions.push({
      title: "text contains",
      description: "Show only rows where ".concat(column.name, " contains ").concat(valueDescription),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().isNull().not().and(filterValues.map(filterValue => column.filter().contains(filterValue)).reduce((prev, curr) => prev.or(curr))), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, values.map(value => "~".concat(toFilterText(value))).join(' || '), operator));
      },
      order: 30,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'text does not contain',
      description: "Show only rows where ".concat(column.name, " does not contain ").concat(valueDescription),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().isNull().or(filterValues.map(filterValue => column.filter().contains(filterValue).not()).reduce((prev, curr) => prev.and(curr))), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, values.map(value => "!~".concat(toFilterText(value))).join(' && '), operator));
      },
      order: 40,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'text starts with',
      description: "Show only rows where ".concat(column.name, " starts with ").concat(valueDescription),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().isNull().not().and(filterValues.map(filterValue => column.filter().invoke('startsWith', filterValue)).reduce((prev, curr) => prev.or(curr))), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, values.map(value => "".concat(toFilterText(value), "*")).join(' || '), operator));
      },
      order: 50,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'text ends with',
      description: "Show only rows where ".concat(column.name, " ends with ").concat(valueDescription),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().isNull().not().and(filterValues.map(filterValue => column.filter().invoke('endsWith', filterValue)).reduce((prev, curr) => prev.or(curr))), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, values.map(value => "*".concat(toFilterText(value))).join(' || '), operator));
      },
      order: 60,
      group: ContextActions.groups.low
    });
    return actions;
  }
  numberFilterActions(column, snapshotValues, quickFilter, operator) {
    var values = Array.from(snapshotValues.keys());
    var valueDesc = values.length === 1 ? "".concat(values) : 'the selected values';
    // We want to show the full unformatted value if it's a number, so user knows which value they are matching
    // If it's a Char we just show the char
    var toFilterText = item => TableUtils.isCharType(column.type) ? String.fromCharCode(item) : "".concat(item);
    var filter = null;
    var filterText = null;
    if (quickFilter) {
      filter = quickFilter.filter;
      filterText = quickFilter.text;
    }
    var actions = [];
    var model = this.irisGrid.props.model;
    var columnIndex = model.getColumnIndexByName(column.name);
    assertNotNull(columnIndex);
    actions.push({
      menuElement: /*#__PURE__*/_jsxs("div", {
        className: "iris-grid-filter-menu-item-value",
        children: [operator ? IrisGridContextMenuHandler.getOperatorAsText(operator) : '', ' ', TextUtils.join(values.slice(0, 20).map(value => "\"".concat(toFilterText(value), "\""))), values.length > 1 && /*#__PURE__*/_jsxs("div", {
          className: "iris-grid-filter-menu-subtitle",
          children: ["(", values.length, " values selected)"]
        })]
      }),
      order: 1,
      group: ContextActions.groups.high
    });
    actions.push({
      title: 'is equal to',
      description: "Show only rows where ".concat(column.name, " is ").concat(valueDesc),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, values.map(value => this.getNumberValueEqualsFilter(column, value)).reduce((acc, curr) => acc.or(curr)), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, values.map(value => "=".concat(toFilterText(value))).join(' || '), operator));
      },
      order: 10,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'is not equal to',
      description: "Show only rows where ".concat(column.name, " is not ").concat(valueDesc),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, values.map(value => this.getNumberValueEqualsFilter(column, value).not()).reduce((acc, curr) => acc.and(curr)), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, values.map(value => "!=".concat(toFilterText(value))).join(' && '), operator));
      },
      order: 20,
      group: ContextActions.groups.low
    });

    // IDS-6092 Less/greater than filters don't make sense for Infinite/NaN
    // TODO (DH-11799): These char filters should work in Bard, with the merge for DH-11040: https://gitlab.eng.illumon.com/illumon/iris/merge_requests/5801
    // They do not work in Powell though, so disable them.
    if (!snapshotValues.has(Number.NaN) && !snapshotValues.has(Number.POSITIVE_INFINITY) && !snapshotValues.has(Number.NEGATIVE_INFINITY) && !TableUtils.isCharType(column.type)) {
      // get the min/max because these are all ge/ne filters
      var maxValue = values.reduce((a, b) => a > b ? a : b);
      var minValue = values.reduce((a, b) => a < b ? a : b);
      var maxFilterValue = this.getFilterValueForNumberOrChar(column.type, maxValue);
      var minFilterValue = this.getFilterValueForNumberOrChar(column.type, minValue);
      var maxValueText = "".concat(maxFilterValue);
      var minValueText = "".concat(minFilterValue);
      actions.push({
        title: 'greater than',
        description: "Show only rows where ".concat(column.name, " is greater than ").concat(maxValueText),
        action: () => {
          this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().greaterThan(maxFilterValue), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, ">".concat(toFilterText(maxValue)), operator));
        },
        order: 30,
        group: ContextActions.groups.low
      });
      actions.push({
        title: 'greater than or equal to',
        description: "Show only rows where ".concat(column.name, " is greater than or equal to ").concat(maxValueText),
        action: () => {
          this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().greaterThanOrEqualTo(maxFilterValue), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, ">=".concat(toFilterText(maxValue)), operator));
        },
        order: 40,
        group: ContextActions.groups.low
      });
      actions.push({
        title: 'less than',
        description: "Show only rows where ".concat(column.name, " is less than ").concat(minValueText),
        action: () => {
          this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().lessThan(minFilterValue), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, "<".concat(toFilterText(minValue)), operator));
        },
        order: 50,
        group: ContextActions.groups.low
      });
      actions.push({
        title: 'less than or equal to',
        description: "Show only rows where ".concat(column.name, " is less than or equal to ").concat(minValueText),
        action: () => {
          this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().lessThanOrEqualTo(minFilterValue), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, "<=".concat(toFilterText(minValue)), operator));
        },
        order: 60,
        group: ContextActions.groups.low
      });
    }
    return actions;
  }
  booleanFilterActions(column, valueText, quickFilter, operator) {
    var actions = [];
    var model = this.irisGrid.props.model;
    var _ref = quickFilter || {},
      filter = _ref.filter,
      filterText = _ref.text;
    var columnIndex = model.getColumnIndexByName(column.name);
    assertNotNull(columnIndex);
    actions.push({
      menuElement: /*#__PURE__*/_jsxs("div", {
        className: "iris-grid-filter-menu-item-value",
        children: [operator ? IrisGridContextMenuHandler.getOperatorAsText(operator) : '', ' ', "\"", valueText !== null && valueText !== void 0 ? valueText : 'null', "\""]
      }),
      order: 1,
      group: ContextActions.groups.high
    });
    actions.push({
      title: 'true',
      description: "Show only rows where ".concat(column.name, " is true"),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().isTrue(), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, 'true', operator));
      },
      order: 10,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'false',
      description: "Show only rows where ".concat(column.name, " is false"),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().isFalse(), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, 'false', operator));
      },
      order: 20,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'is null',
      description: "Show only rows where ".concat(column.name, " is null"),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().isNull(), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, 'null', operator));
      },
      order: 30,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'is not null',
      description: "Show only rows where ".concat(column.name, " is not null"),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().isNull().not(), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, '!null', operator));
      },
      order: 40,
      group: ContextActions.groups.low
    });
    return actions;
  }
  dateFilterActions(column, snapshotValues, dateFilterFormatter, previewFilterFormatter, quickFilter, operator) {
    var dh = this.dh;
    var values = Array.from(snapshotValues.keys());
    var filterValues = values.map(value => dh.FilterValue.ofNumber(value));
    var valueDesc = filterValues.length === 1 ? previewFilterFormatter.format(values[0]) : 'the selected values';
    var maxValue = values.reduce((a, b) => a > b ? a : b);
    var minValue = values.reduce((a, b) => a < b ? a : b);
    var maxFilterValue = dh.FilterValue.ofNumber(maxValue);
    var minFilterValue = dh.FilterValue.ofNumber(minValue);
    var maxDateText = dateFilterFormatter.format(maxValue);
    var minDateText = dateFilterFormatter.format(minValue);
    var maxPreviewText = previewFilterFormatter.format(maxValue);
    var minPreviewText = previewFilterFormatter.format(minValue);
    var filter = null;
    var filterText = null;
    if (quickFilter) {
      filter = quickFilter.filter;
      filterText = quickFilter.text;
    }
    var model = this.irisGrid.props.model;
    var columnIndex = model.getColumnIndexByName(column.name);
    assertNotNull(columnIndex);
    var actions = [];
    actions.push({
      menuElement: /*#__PURE__*/_jsxs("div", {
        className: "iris-grid-filter-menu-item-value",
        children: [operator ? IrisGridContextMenuHandler.getOperatorAsText(operator) : '', ' ', TextUtils.join(values.slice(0, 20).map(value => "\"".concat(previewFilterFormatter.format(value), "\""))), values.length > 1 && /*#__PURE__*/_jsxs("div", {
          className: "iris-grid-filter-menu-subtitle",
          children: ["(", values.length, " values selected)"]
        })]
      }),
      order: 1,
      group: ContextActions.groups.high
    });
    actions.push({
      title: 'date is',
      description: "Show only rows where ".concat(column.name, " is ").concat(valueDesc),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, filterValues.map(valueFilter => column.filter().eq(valueFilter)).reduce((acc, curr) => acc.or(curr)), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, values.map(value => "=".concat(dateFilterFormatter.format(value))).join(' || '), operator));
      },
      order: 10,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'date is not',
      description: "Show only rows where ".concat(column.name, " is not ").concat(valueDesc),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, filterValues.map(valueFilter => column.filter().notEq(valueFilter)).reduce((acc, curr) => acc.and(curr)), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, values.map(value => "!=".concat(dateFilterFormatter.format(value))).join(' && '), operator));
      },
      order: 20,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'date is before',
      description: "Show only rows where ".concat(column.name, " is before ").concat(minPreviewText),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().lessThan(minFilterValue), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, "<".concat(minDateText), operator));
      },
      order: 30,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'date is before or equal',
      description: "Show only rows where ".concat(column.name, " is before or equal to ").concat(minPreviewText),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().lessThanOrEqualTo(minFilterValue), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, "<=".concat(minDateText), operator));
      },
      order: 40,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'date is after',
      description: "Show only rows where ".concat(column.name, " is greater than ").concat(maxPreviewText),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().greaterThan(maxFilterValue), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, ">".concat(maxDateText), operator));
      },
      order: 50,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'date is after or equal',
      description: "Show only rows where ".concat(column.name, " is after or equal to ").concat(maxPreviewText),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().greaterThanOrEqualTo(maxFilterValue), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, ">=".concat(maxDateText), operator));
      },
      order: 60,
      group: ContextActions.groups.low
    });
    return actions;
  }
  emptyStringFilterActions(column, quickFilter, operator) {
    var dh = this.dh;
    var filterValue = dh.FilterValue.ofString('');
    var newQuickFilter = quickFilter;
    if (!newQuickFilter) {
      newQuickFilter = {
        filter: null,
        text: null
      };
    }
    var _newQuickFilter2 = newQuickFilter,
      filter = _newQuickFilter2.filter,
      filterText = _newQuickFilter2.text;
    var actions = [];
    var model = this.irisGrid.props.model;
    var columnIndex = model.getColumnIndexByName(column.name);
    assertNotNull(columnIndex);
    actions.push({
      menuElement: /*#__PURE__*/_jsxs("div", {
        className: "iris-grid-filter-menu-item-value",
        children: [operator ? IrisGridContextMenuHandler.getOperatorAsText(operator) : '', ' ', /*#__PURE__*/_jsx("i", {
          className: "text-muted",
          children: "empty"
        })]
      }),
      order: 1,
      group: ContextActions.groups.high
    });
    actions.push({
      title: 'is empty string',
      description: "Show only rows where ".concat(column.name, " is empty"),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().eq(filterValue), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, "=", operator));
      },
      order: 10,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'is not empty string',
      description: "Show only rows where ".concat(column.name, " is not empty"),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().notEq(filterValue), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, "!=", operator));
      },
      order: 20,
      group: ContextActions.groups.low
    });
    return actions;
  }
  nullFilterActions(column, quickFilter, operator) {
    var filter = null;
    var filterText = null;
    if (quickFilter) {
      filter = quickFilter.filter;
      filterText = quickFilter.text;
    }
    var actions = [];
    var model = this.irisGrid.props.model;
    var columnIndex = model.getColumnIndexByName(column.name);
    assertNotNull(columnIndex);
    actions.push({
      menuElement: /*#__PURE__*/_jsxs("div", {
        className: "iris-grid-filter-menu-item-value",
        children: [operator ? IrisGridContextMenuHandler.getOperatorAsText(operator) : '', ' ', /*#__PURE__*/_jsx("i", {
          className: "text-muted",
          children: "null"
        })]
      }),
      order: 1,
      group: ContextActions.groups.high
    });
    actions.push({
      title: 'is null',
      description: "Show only rows where ".concat(column.name, " is null"),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().isNull(), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, 'null', operator));
      },
      order: 10,
      group: ContextActions.groups.low
    });
    actions.push({
      title: 'is not null',
      description: "Show only rows where ".concat(column.name, " is not null"),
      action: () => {
        this.irisGrid.setQuickFilter(columnIndex, IrisGridContextMenuHandler.getQuickFilterCondition(filter, column.filter().isNull().not(), operator), IrisGridContextMenuHandler.getQuickFilterText(filterText, '!null', operator));
      },
      order: 20,
      group: ContextActions.groups.low
    });
    return actions;
  }
  sortByActions(column, modelColumn, columnSort) {
    var theme = this.irisGrid.getTheme();
    var contextMenuSortIconColor = theme.contextMenuSortIconColor;
    var sortActions = [{
      title: "".concat(column.name, " Ascending"),
      order: 10,
      action: () => {
        this.irisGrid.sortColumn(modelColumn, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.ascending);
      },
      icon: this.checkColumnSort(columnSort, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.ascending) ? vsRemove : undefined,
      iconColor: contextMenuSortIconColor
    }, {
      title: "".concat(column.name, " Descending"),
      order: 20,
      action: () => {
        this.irisGrid.sortColumn(modelColumn, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.descending);
      },
      icon: this.checkColumnSort(columnSort, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.descending) ? vsRemove : undefined,
      iconColor: contextMenuSortIconColor
    }, {
      title: "Remove Sort",
      order: 50,
      action: () => {
        this.irisGrid.sortColumn(modelColumn, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.none, false, true);
      },
      disabled: !columnSort
    }];
    if (TableUtils.isNumberType(column.type)) {
      sortActions.push({
        title: "ABS(".concat(column.name, ") Ascending"),
        order: 30,
        action: () => {
          this.irisGrid.sortColumn(modelColumn, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.ascending, true);
        },
        icon: this.checkColumnSort(columnSort, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.ascending, true) ? vsRemove : undefined,
        iconColor: contextMenuSortIconColor
      });
      sortActions.push({
        title: "ABS(".concat(column.name, ")  Descending"),
        order: 40,
        action: () => {
          this.irisGrid.sortColumn(modelColumn, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.descending, true);
        },
        icon: this.checkColumnSort(columnSort, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.descending, true) ? vsRemove : undefined,
        iconColor: contextMenuSortIconColor
      });
    }
    return sortActions;
  }
  additionalSortActions(column, columnIndex) {
    var theme = this.irisGrid.getTheme();
    var contextMenuSortIconColor = theme.contextMenuSortIconColor;
    var additionalSortActions = [{
      title: 'Add Sort By',
      menuElement: /*#__PURE__*/_jsxs("div", {
        className: "btn-context-menu menu-title",
        children: [/*#__PURE__*/_jsx("span", {
          className: "icon",
          children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: vsRemove,
            style: {
              color: contextMenuSortIconColor !== null && contextMenuSortIconColor !== void 0 ? contextMenuSortIconColor : undefined
            }
          })
        }), /*#__PURE__*/_jsx("span", {
          className: "title",
          children: "Add Additional Sort"
        }), /*#__PURE__*/_jsx("span", {
          className: "shortcut",
          children: ContextActionUtils.isMacPlatform() ? '⌘Click' : 'Ctrl+Click'
        })]
      }),
      order: 1
    }, {
      title: "".concat(column.name, " Ascending"),
      order: 10,
      action: () => {
        this.irisGrid.sortColumn(columnIndex, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.ascending, false, true);
      }
    }, {
      title: "".concat(column.name, " Descending"),
      order: 20,
      action: () => {
        this.irisGrid.sortColumn(columnIndex, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.descending, false, true);
      }
    }];
    if (TableUtils.isNumberType(column.type)) {
      additionalSortActions.push({
        title: "ABS(".concat(column.name, ") Ascending"),
        order: 30,
        action: () => {
          this.irisGrid.sortColumn(columnIndex, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.ascending, true, true);
        }
      });
      additionalSortActions.push({
        title: "ABS(".concat(column.name, ")  Descending"),
        order: 40,
        action: () => {
          this.irisGrid.sortColumn(columnIndex, IrisGridContextMenuHandler.COLUMN_SORT_DIRECTION.descending, true, true);
        }
      });
    }
    return additionalSortActions;
  }
  checkColumnSort(columnSort) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var isAbs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!columnSort) {
      return false;
    }
    return columnSort.direction === direction && columnSort.isAbs === isAbs;
  }
}
_defineProperty(IrisGridContextMenuHandler, "GROUP_EDIT", ContextActions.groups.high + 10);
_defineProperty(IrisGridContextMenuHandler, "GROUP_HIDE_COLUMNS", ContextActions.groups.high + 25);
_defineProperty(IrisGridContextMenuHandler, "GROUP_FILTER", ContextActions.groups.high + 50);
_defineProperty(IrisGridContextMenuHandler, "GROUP_EXPAND_COLLAPSE", ContextActions.groups.high + 55);
_defineProperty(IrisGridContextMenuHandler, "GROUP_GOTO", ContextActions.groups.high + 60);
_defineProperty(IrisGridContextMenuHandler, "GROUP_SORT", ContextActions.groups.high + 75);
_defineProperty(IrisGridContextMenuHandler, "GROUP_COPY", ContextActions.groups.high + 100);
_defineProperty(IrisGridContextMenuHandler, "GROUP_FORMAT", ContextActions.groups.high + 150);
_defineProperty(IrisGridContextMenuHandler, "GROUP_VIEW_CONTENTS", ContextActions.groups.high + 175);
_defineProperty(IrisGridContextMenuHandler, "COLUMN_SORT_DIRECTION", {
  ascending: 'ASC',
  descending: 'DESC',
  none: null
});
export default IrisGridContextMenuHandler;
//# sourceMappingURL=IrisGridContextMenuHandler.js.map